import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Conversion} from '../../models/conversion';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ConversionService extends AbstractModelService<Conversion> {
  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/conversion', Conversion);
  }

  getDownloadUrl(parameters: any = {}): string {
    parameters['token'] = this.authService.getBearer();

    return this.apiClient.getUrl(this.routePath + '/download', parameters);
  }
}
